import { useState } from "react";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/NewCustomerUserType.css";

const NewCustomerUserType = ({showNewCustomerUserTypeWindow,setShowNewCustomerUserTypeWindow,setShowNewCustomerUserWindow,setShowAddExistingCustomerUserWindow}) =>{
    const [userType,setUserType] = useState('');
    const disposeWindow = () =>{
        setUserType('');
        setShowNewCustomerUserTypeWindow(false);
    };
    if(!showNewCustomerUserTypeWindow) return null;
    return(
        <div className="tenant-administrator-new-customer-user-type-parent-container">
            <div className="tenant-administrator-new-customer-user-type-container">
                <div className="tenant-administrator-new-customer-user-type-header">
                    <h1>Select user type to add</h1>
                    <p onClick={() =>disposeWindow()}>&#10006;</p>
                </div>
                <div className="tenant-administrator-new-customer-user-type-body">
                    <div className="tenant-administrator-new-customer-user-type-select-container">
                        <select value={userType} onChange={(e) => setUserType(e.target.value)}>
                            <option value='' disabled>Please select</option>
                            <option value='new'>New user</option>
                            <option value='existing'>Existing user</option>
                        </select>
                    </div>
                    <div className="tenant-administrator-new-customer-user-type-buttons-container">
                        <button onClick={() =>{
                            if(!userType || userType === ''){
                                window.alert('Please select the customer type');
                            }
                            else if(userType === 'new'){
                                setShowNewCustomerUserWindow(true);
                                disposeWindow();
                            }
                            else if(userType === 'existing'){
                                setShowAddExistingCustomerUserWindow(true);
                                disposeWindow();
                            }
                        }}>Proceed</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default NewCustomerUserType;